module.exports = __webpack_public_path__ + "img/static-move-truck@2x.36eb70bf.png";